import { faqs } from '@/mocks/categories';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-24 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full border border-secondary-300/60 bg-secondary-100/50 text-secondary-900 text-xs font-medium mb-4">
            FAQ
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-950 mb-3">
            Frequently Asked Questions
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            Everything you need to know about the <strong>AllChinaBuy Spreadsheet</strong>.
          </p>
        </div>

        <div className="flex flex-col gap-3 md:gap-4">
          {faqs.map((faq, idx) => (
            <details key={idx} className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden">
              <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <span className="w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-45 transition-transform flex-shrink-0">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <div className="px-6 pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}